import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    errorsPresent: Boolean,
    jobCompleted: Boolean,
    errorRedirectUrl: String,
    completionRedirectUrl: String
  }

  connect() {
    if (this.errorsPresentValue) {
      window.location.href = this.errorRedirectUrlValue
    }
    else if (this.jobCompletedValue) {
      window.location.href = this.completionRedirectUrlValue
    }
  }
}